import React, { useEffect } from "react";

const Toast = ({ message, type = "info", onClose, duration = 5000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getTypeStyles = () => {
    switch (type) {
      case "success":
        return {
          background: "#00c875",
          color: "#ffffff",
          icon: "✓",
        };
      case "error":
        return {
          background: "#d83a52",
          color: "#ffffff",
          icon: "✕",
        };
      case "warning":
        return {
          background: "#ffa500",
          color: "#ffffff",
          icon: "⚠",
        };
      default:
        return {
          background: "#0073ea",
          color: "#ffffff",
          icon: "ℹ",
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "12px 16px",
        background: styles.background,
        color: styles.color,
        borderRadius: 8,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        minWidth: 300,
        maxWidth: 500,
        fontSize: 14,
        fontWeight: 500,
        zIndex: 10000,
        animation: "slideIn 0.3s ease-out",
      }}
      onClick={onClose}
      role="alert"
    >
      <span style={{ fontSize: 18, fontWeight: 600, flexShrink: 0 }}>
        {styles.icon}
      </span>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        style={{
          background: "transparent",
          border: "none",
          color: styles.color,
          cursor: "pointer",
          fontSize: 20,
          padding: 0,
          width: 24,
          height: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          opacity: 0.8,
        }}
        aria-label="Close notification"
      >
        ×
      </button>
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Toast;

